module.exports = __webpack_public_path__ + "img/loan_settle_active.8ea66ecc.svg";